import { createFileRoute } from "@tanstack/react-router";

import { SetupConsole } from "@/features/wonda/components/SetupConsole";

export const Route = createFileRoute(
  "/_authenticated/(wonda)/_wonda/account/setup",
)({
  component: SetupTab,
});

function SetupTab() {
  return <SetupConsole variant="tab" />;
}
